import get from 'lodash/get'
import flatMap from 'lodash/flatMap'
import formValueSelector from 'redux-form/lib/formValueSelector'
import {createSelector} from 'reselect'

import {REDUX} from '../../const'

export const rentToKeep = (state) => get(state, 'rentToKeep')

export const discountAmount = (state) => get(rentToKeep(state), 'discountAmount')
export const isFetchingCalculatedTotals = (state) =>
  get(rentToKeep(state), 'isFetchingCalculatedTotals')
export const hasCalculateTotalsFailed = (state) =>
  get(rentToKeep(state), 'hasCalculateTotalsFailed')
export const currentStep = (state) => get(rentToKeep(state), 'currentStep')
export const errors = (state) => get(rentToKeep(state), 'errors')
export const eventId = (state) => get(rentToKeep(state), 'eventId')
export const hasFetchingEligibleRTKItemsFailed = (state) =>
  get(rentToKeep(state), 'hasFetchingEligibleRTKItemsFailed')
export const hasSavingBillingAddressFailed = (state) =>
  get(rentToKeep(state), 'hasSavingBillingAddressFailed')
export const isFetchingEligibleRTKItems = (state) =>
  get(rentToKeep(state), 'isFetchingEligibleRTKItems')
export const isRentToKeepOfferActive = (state) => get(rentToKeep(state), 'isRentToKeepOfferActive')
export const isSubmittingBillingInformation = (state) =>
  get(rentToKeep(state), 'isSubmittingBillingInformation')
export const isSubmittingPurchase = (state) => get(rentToKeep(state), 'isSubmittingPurchase')
export const itemsToPurchase = (state) => get(rentToKeep(state), 'itemsToPurchase')
export const orders = (state) => get(rentToKeep(state), 'orders')
export const subtotal = (state) => get(rentToKeep(state), 'subtotal')
export const tax = (state) => get(rentToKeep(state), 'tax')
export const total = (state) => get(rentToKeep(state), 'total')

export const rtkFormValueSelector = formValueSelector(REDUX.RTK_BILLING_FORM)
export const isChargingCardOnFile = (state) =>
  rtkFormValueSelector(state, 'billing.address.isChargingCardOnFile')

export const allOrderItems = createSelector(orders, ($orders) =>
  flatMap($orders, (order) => order.rentToKeepItems),
)

export const hasEligibleRtkItems = createSelector(allOrderItems, (rtkItems) => !!rtkItems.length)

export const hasReplacements = createSelector(orders, ($orders) => $orders.length > 1)

// Using the orderItemIds and productSetIds of the purchase items
// find more detail about these items by retrieving it from the order.
// Items are unique by orderItemId + productSetId
export const purchaseItemMetadata = createSelector(
  itemsToPurchase,
  allOrderItems,
  (purchaseItems, orderItems) =>
    orderItems.filter((orderItem) =>
      purchaseItems.some(
        (purchaseItem) =>
          purchaseItem.productSetId === orderItem.productSetId &&
          purchaseItem.orderItemId === orderItem.orderLookProductId,
      ),
    ),
)

export const shouldShowErrorModal = createSelector(errors, ($errors) => !!$errors.length)

export const errorToDisplay = createSelector(errors, ($errors) => $errors[0])

export const areAllItemsAlreadyPurchased = createSelector(orders, ($orders) =>
  $orders.every(({rentToKeepItems}) => rentToKeepItems.every(({isPurchased}) => isPurchased)),
)
